import { Injectable } from "@angular/core";
import _ = require("lodash");
import { Observable } from "rxjs/Observable";
import { Subject } from "rxjs/Subject";
import { environment } from "../../../environments/environment";
import { FilterCriteria } from "../../models/filter-criteria";
import { ILimitedResult } from "../../models/limitedResult";
import { StoreIdentifier } from "../../models/store-identifier.model";
import { BaseService } from "../api-base.service";
import { ReconApiService } from "../recon-api.service";
import { HttpClient } from "@angular/common/http";

@Injectable()
export class StoreIdentifierService {
  //  Observables
  private formCompleteSource = new Subject<StoreIdentifier>();

  formCompleteSource$ = this.formCompleteSource.asObservable();

  private readonly timeout: number = 30000;
  private readonly basePath: string = "Stores";

  constructor(
    private http: HttpClient,
    private apiBase: BaseService,
    private reconApiService: ReconApiService
  ) {}

  public async loadStoreIdentifiers(
    clientId: string,
    criteria: FilterCriteria
  ): Promise<ILimitedResult<StoreIdentifier>> {
    const url = `${environment.reconApiRoot.url}/client/${clientId}/${
      this.basePath
    }/Identifiers/${criteria.toString()}`;
    const response = await this.http
      .get(url, { headers: this.apiBase.getHeaders() })
      .timeoutWith(
        this.timeout,
        Observable.throw(new Error("Timeout exceeded."))
      )
      .toPromise()
      .catch((error) => {
        console.log(
          `Error occurred at ${new Date()} status: ${error.status.toString()}`
        );
        this.reconApiService.logToElasticSearchFromUI(
          error,
          `${environment.reconApiRoot.url}/client/${clientId}/${
            this.basePath
          }/Identifiers/${criteria.toString()}`
        );
      });
    return response;
  }

  notifyFormComplete(store: StoreIdentifier): void {
    // This is being added to debug a production issue re: SDHEAL-4255
    console.log("Notifying Form Complete. via StoreIdentifierService");
    console.log(store);
    console.log(new Date().getTime());

    this.formCompleteSource.next(store);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/remittance-entry/store-identifier.service.ts